const $ = jQuery;

class Billboard {
    constructor(el){
        this.el = el;
        this.observer = new MutationObserver( ()=> this.check());
        this.observer.observe( el, {
            childList: true,
            subtree: true
        });
        this.check();
    }

    check(){
        if( !$(this.el).find('a').length ){
            // lets grow this bad boy
            return;
        }

        this.observer.disconnect();
        this.el.scrollHeight;
        $(this.el).animate({
            height: this.el.scrollHeight
        }, 1200, () => {
            $(this.el).css({height: 'auto'});
        })
    }
}

export default {
    init(el){
        new Billboard(el);
    }
}